
(function(){
  document.documentElement.classList.add('pb-kinetic-ready');

  var selectors=[
    '.aura-status','.aura-title','.aura-actions','.aura-live',
    '.aura-command','.aura-identity','.identity-map',
    '.aura-vault','.aura-services','.aura-concierge',
    '.stores-wrap','.aura-quote','.motion-footer'
  ];
  var els=[];
  selectors.forEach(function(sel){
    document.querySelectorAll(sel).forEach(function(el){
      if(!el.hasAttribute('data-pb-kinetic')){
        el.setAttribute('data-pb-kinetic','');
        els.push(el);
      }
    });
  });

  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add('pb-in');
          io.unobserve(e.target);
        }
      });
    },{threshold:.12,rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(el){io.observe(el)});
  }else{
    els.forEach(function(el){el.classList.add('pb-in')});
  }

  /* staggered kinetic accents to avoid simultaneous movement */
  var headings=document.querySelectorAll('.aura-title h2,.aura-identity h2,.aura-services h2,.aura-concierge h2');
  headings.forEach(function(el,i){
    el.classList.add(i%2===0?'pb-k-drift':'pb-k-shake');
    el.style.animationDelay=(i*1.1)+'s';
  });

  /* premium tap bubble only on interactive PB controls */
  document.addEventListener('pointerdown',function(e){
    var hit=e.target.closest('a,button,.store-card');
    if(!hit) return;
    var b=document.createElement('span');
    b.className='pb-tap-bubble';
    b.style.left=e.clientX+'px'; b.style.top=e.clientY+'px';
    document.body.appendChild(b);
    setTimeout(function(){b.remove()},760);
  },{passive:true});
})();
